module.exports = __webpack_public_path__ + "media/images/sale_crm/help_desk-08f1d02c649be8d86a2d0eb37822cac6.svg";